import styled from '../../styles/styledComponents/themeComponents';

export const NoticeStyle = styled.div`
  color: #6200ea;
  font-size: 11px;
  font-weight: 700;
  line-height: 20px;
  p {
    margin-bottom: 0;
  }
`;
